import React from "react";

import styled from "styled-components";
import { BootstrapModal } from "../../../BootstrapModal/Modal";
import Button from "../../../Button/Button";
import { CgClose } from "react-icons/cg";
import { useDeletePropertyLevel2 } from "../../../../hooks/useContent";
import Typography from "../../../Typography/Typography";
import { Wrapper } from "../../../../theme/GlobalStyle";
import { useRecoilState } from "recoil";
import {
  ContentUnitModal,
  RefreshTableLevelSecond,
} from "../../../../shared/content-unit";
import Spinner from "react-bootstrap/Spinner";

function DeletePropertyLevel2({ handleClose, show }) {
  const {
    mutateAsync: deletePropertyReq,
    isLoading: reqLoading,
    isError: reqError,
  } = useDeletePropertyLevel2();

  const [modulasvalue, setModualValue] = useRecoilState(ContentUnitModal);
  const [refreshEffect, setRefreshEffect] = useRecoilState(
    RefreshTableLevelSecond
  );

  const handleDelete = () => {
    const { deletePropertyLevel2 } = modulasvalue;
    deletePropertyReq({
      feature_id: deletePropertyLevel2.value?.IdFeatureValues,
    }).then((res) => {
      setRefreshEffect(!refreshEffect);
      handleClose();
    });
    setModualValue({
      ...modulasvalue,
    });
  };

  return (
    <BootstrapModal
      modaltitle="حذف ویژگی سطح 2"
      handleClose={handleClose}
      show={show}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <DeletePropertyStyle>
        <Wrapper>
          <Typography size={"13px"}>
            {`ایا از حذف ویژگی  ${modulasvalue?.deletePropertyLevel2?.value?.LableProperties} مطمین هستید ؟`}
          </Typography>
        </Wrapper>
        <div className="more-btn">
          <div className="col-6 d-flex button-sub">
            <Button
              className=""
              bgColor="#009ef7"
              color="#fff"
              onclick={() => {
                !reqLoading && handleDelete();
              }}
            >
              {reqLoading ? (
                <Spinner animation="border" size="sm" />
              ) : (
                <Typography size={"13px"} primary={"#fff"}>
                  بله, حذف
                </Typography>
              )}
            </Button>
          </div>
          <div className="col-6">
            <Button
              className=""
              bgColor="#f1416c"
              color="#fff"
              onclick={handleClose}
            >
              <Typography size={"13px"} primary={"#fff"}>
                انصراف
              </Typography>
            </Button>
          </div>
        </div>
      </DeletePropertyStyle>
    </BootstrapModal>
  );
}

const DeletePropertyStyle = styled.div`
  width: 100%;
  height: 80px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .more-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: start;
    flex-wrap: nowrap;
    gap: 1rem;
    margin-top: 1rem;
  }
`;

export default DeletePropertyLevel2;
